import React from "react";
import _ from "lodash";
import moment from "moment";
import { FormattedMessage } from "react-intl";

import { getFormatted } from "helpers/formatting";
import DetailView from "components/DetailView";
import { ROLE_IDS } from "constants/.";

const OrderDetailsCard = ({ currentItem }) => (
  <DetailView
    renderExpanded={() => (
      <div className="card-row">
        <div className="card-column">
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="ORDERS_TYPE" />
            </span>
            <h3 className="card-item-value">
              {_.get(currentItem, "TypeId", "-")}
            </h3>
          </div>
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="ORDERS_RATE" />
            </span>
            <h3 className="card-item-value">
              {ROLE_IDS[currentItem.RoleId] === "Buyer"
                ? getFormatted(currentItem.BuyerAgentCommission, "percent")
                : ROLE_IDS[currentItem.RoleId] === "Seller"
                  ? getFormatted(currentItem.SellerAgentCommission, "percent")
                  : "-"}
            </h3>
          </div>
        </div>
        <div className="card-column">
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="ORDERS_BUYER_REP" />
            </span>
            <h3 className="card-item-value">
              {_.get(currentItem, "BuyerAgent.Name", "-")}
            </h3>
          </div>
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="ORDERS_SELLER_REP" />
            </span>
            <h3 className="card-item-value">
              {_.get(currentItem, "SellerAgent.Name", "-")}
            </h3>
          </div>
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="ORDERS_REF" />
            </span>
            <h3 className="card-item-value">
              {currentItem.ExternalReferenceNumber || "-"}
            </h3>
          </div>
        </div>
        <div className="card-column">
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="DELIVERIES_BIO" />
            </span>
            <h3 className="card-item-value">
              <FormattedMessage id={currentItem.Bio ? "YES" : "NO"} />
            </h3>
          </div>
          <div className="card-item">
            <span className="card-item-label">
              <FormattedMessage id="ORDERS_SKAL" />
            </span>
            <h3 className="card-item-value">{currentItem.SkalNumber || "-"}</h3>
          </div>
        </div>
      </div>
    )}
  >
    <div className="card-row">
      <div className="card-column">
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="PURCHASE_TYPE" />
          </span>
          <h3 className="card-item-value">{currentItem.RoleId}</h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_VERSION_DATE" />
          </span>
          <h3 className="card-item-value">
            {currentItem.VersionDate
              ? moment(currentItem.VersionDate).format("DD-MM-YYYY")
              : "-"}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_FROM_DATE" />
          </span>
          <h3 className="card-item-value">
            {currentItem.DeliveryPeriodStart
              ? moment(currentItem.DeliveryPeriodStart).format("DD-MM-YYYY")
              : "-"}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="DELIVERIES_TILL_DATE" />
          </span>
          <h3 className="card-item-value">
            {currentItem.DeliveryPeriodEnd
              ? moment(currentItem.DeliveryPeriodEnd).format("DD-MM-YYYY")
              : "-"}
          </h3>
        </div>
      </div>
      <div className="card-column">
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="HARVEST_YEAR" />
          </span>
          <h3 className="card-item-value">
            {_.get(currentItem, "HarvestYear", "-")}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_AMOUNT_EX_BTW" />
          </span>
          <h3 className="card-item-value">
            {currentItem.TotalAmount &&
            ROLE_IDS[currentItem.RoleId] !== "Supplier"
              ? getFormatted(currentItem.TotalAmount, "currency")
              : "-"}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_COVER" />
          </span>
          <h3 className="card-item-value">
            <FormattedMessage id={currentItem.InCoverScheme ? "YES" : "NO"} />
          </h3>
        </div>
      </div>
      <div className="card-column">
        <div className="card-item column">
          <span className="card-item-label">
            {currentItem.DeliveryTypeId === "Locatie derden" ? (
              <FormattedMessage id="ORDERS_DELIVERY_ADDRESS" />
            ) : (
              currentItem.DeliveryTypeId
            )}
          </span>
          <div className="card-item-value">
            <h3>{_.get(currentItem, "DeliveryAddress.Name", "-")}</h3>
            <h3>{_.get(currentItem, "DeliveryAddress.Address1", "-")}</h3>
            {currentItem.DeliveryAddress && (
              <h3>
                {currentItem.DeliveryAddress.ZipCode}{" "}
                {currentItem.DeliveryAddress.City}
              </h3>
            )}
          </div>
        </div>
      </div>
    </div>
  </DetailView>
);

export default OrderDetailsCard;
